import {Component, inject, Input, OnDestroy, OnInit,} from '@angular/core';
import {IndexIoService} from '../../../services/index-io.service';
import {NgClass, NgIf} from '@angular/common';
import {Router} from '@angular/router';
import {ProgressSpinner} from 'primeng/progressspinner';
import { Subscription } from 'rxjs';

@Component({
  selector: 'bnpp-indx-index-headerinfo',
  imports: [
    NgClass,
    NgIf,
    ProgressSpinner
  ],
  templateUrl: './index-headerinfo.component.html',
  styleUrl: './index-headerinfo.component.scss',
  standalone: true,
})
export class IndexHeaderinfoComponent implements OnInit ,OnDestroy{
  private indexInfoService = inject(IndexIoService);
  @Input() mdsCode:string= '';
  livePrice: string = '';
  private priceSub?: Subscription;
  indexHeaderInfo = this.indexInfoService.indexHeaderInfo;
  indexSubProductInfo = this.indexInfoService.indexSubProductInfo;

  constructor(private  router:Router) {
  }

  goHome():void{
    this.router.navigate(['/home']);
  }

  get hasLivePrice(): boolean {
    const hasFlag = !!this.indexSubProductInfo?.()?.LivePrice;
    const hasValue = typeof this.livePrice === 'string' && this.livePrice.trim().length > 0;
    return hasFlag && hasValue;
  }

  ngOnInit(): void {
    this.indexInfoService.getIndexHeaderInfo(this.mdsCode);
    this.indexInfoService.getSubProductInfo(this.mdsCode);
    this.priceSub = this.indexInfoService.subscribeTREPService(this.mdsCode).subscribe(price=>this.livePrice=price);
  }

  protected readonly parseFloat = parseFloat;

  getReturnClass(val:string) :string{
    const num =parseFloat(val);
    if(isNaN(num)) return  'text-gray-400';
    return  num>0 ? 'font-bold text-lg text-green-600': 'font-bold text-lg text-red-600'
  }

  ngOnDestroy(): void {
    this.priceSub?.unsubscribe();
    this.indexInfoService.unsubscribeTREPService(this.mdsCode);
  }
}
